import { hideAllInMain } from './uxManagement';
import { getUserInformation } from './localStorage';

export function showStart() {
  hideAllInMain();
  document.getElementById('start-container').classList.add('visible');
  document.getElementById('search-container').classList.add('visible');
  document.getElementById('cart-container').classList.add('visible');
  if (getUserInformation('CustomerName')) {
    document.getElementById('wl-user').innerText = getUserInformation('CustomerName');
  }
}
